<template>
  <v-layout wrap>
    <v-flex xs12 class="amber blue-grey--text text--darken-4 text-xs-left px-2 py-3">
      <span class="subheading font-weight-bold">申込み内容</span>
    </v-flex>
    <v-flex xs12 px-2>
      <v-text-field required v-model="form.title"
        label="申込名（学校名）"
        :rules="rules.title"></v-text-field>
    </v-flex>
    <v-flex xs12 sm4 px-2>
      <v-select required v-model="form.type"
        label="申込の種類"
        :items="getTypeItems"
        item-text="text"
        item-value="value"
        :rules="rules.type"></v-select>
    </v-flex>
    <v-flex xs12 sm4 px-2>
      <v-select required v-model="form.country"
        label="留学先の国"
        :items="getNationItems"
        item-text="text"
        item-value="value"
        :rules="rules.country"></v-select>
    </v-flex>
    <v-flex xs12 sm4 px-2>
      <v-text-field required v-model="form.city"
        label="留学先の都市"
        :rules="rules.city"></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 v-if="!isAcademicCourse">
      <v-subheader class="amber blue-grey--text text--darken-4 py-3 px-2 font-weight-bold">コース</v-subheader>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile v-for="item in getFormCourseItems" :key="item.id" class="my-3">
          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'school']"></font-awesome-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title class="caption"><span class="font-weight-bold">レッスン内容：</span>{{ item.lesson.size + item.lesson.unit }}</v-list-tile-sub-title>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title class="caption">
              <span class="font-weight-bold">期間：</span>
              <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
              <span v-if="item.term && item.term.size">{{ item.term.size + item.term.unit }}</span>
              <span v-if="item.extra && item.extra.size">{{ '+' + item.extra.size + item.extra.unit }}</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-menu bottom offset-y>
              <v-btn icon slot="activator" color="blue--text text--darken-2"><v-icon>more_vert</v-icon></v-btn>
              <v-list>
                <v-list-tile @click="edit({ type: 'course', data: item })">
                  <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>編集する</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="remove({ type: 'courses', data: item })">
                  <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon></v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>削除する</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile class="blue--text text--darken-2" @click.stop="$refs.course.open()">
          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>コースを追加する</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon flat :disabled="true"></v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex xs12 sm6 v-if="!isAcademicCourse">
      <v-subheader class="amber blue-grey--text text--darken-4 py-3 px-2 font-weight-bold">滞在先</v-subheader>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile v-for="item in getFormStayItems" :key="item.id" class="my-3">
          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'bed']"></font-awesome-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-sub-title class="caption"><span class="font-weight-bold">宿泊タイプ：</span>{{ item.type }}</v-list-tile-sub-title>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title class="caption">
              <span class="font-weight-bold">期間：</span>
              <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
              <span v-if="item.term && item.term.size">{{ item.term.size + item.term.unit }}</span>
              <span v-if="item.extra && item.extra.size">{{ '+' + item.extra.size + item.extra.unit }}</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-menu bottom offset-y>
              <v-btn icon slot="activator" color="blue--text text--darken-2"><v-icon>more_vert</v-icon></v-btn>
              <v-list>
                <v-list-tile @click="edit({ type: 'stay', data: item })">
                  <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"></font-awesome-icon></v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>編集する</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="remove({ type: 'stays', data: item })">
                  <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"></font-awesome-icon></v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>削除する</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile class="blue--text text--darken-2" @click.stop="$refs.stay.open()">
          <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>滞在先を追加する</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon flat :disabled="true"></v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-flex>
    <CourseModal ref="course" @done="insert"></CourseModal>
    <StayModal ref="stay" @done="insert"></StayModal>
  </v-layout>
</template>
<script>
import CourseModal from '../../modals/course'
import StayModal from '../../modals/stay'
export default {
  name: 'mainForm',
  components: {
    CourseModal,
    StayModal
  },
  props: [
    'status'
  ],
  data () {
    return {
      meta: {
        types: {
          'prog-short': '短期留学',
          'prog-long': '長期留学',
          'prog-wh': 'ワーホリ',
          'prog-academic': '高校・大学正規留学'
        }
      },
      form: {
        valid: true,
        id: '',
        type: '',
        title: '',
        country: '',
        city: '',
        courses: [],
        stays: []
      },
      rules: {
        type: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        city: [
          v => !!v || '必須項目です'
        ],
        title: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function (req) {
      const { values } = req
      this.$set(this, 'form', values ? {
        id: values.id ? values.id : this.form.id,
        type: values.type ? values.type : this.form.type,
        title: values.title ? values.title : this.form.title,
        country: values.country ? values.country : this.form.country,
        city: values.city ? values.city : this.form.city,
        courses: values.courses ? values.courses : this.form.courses,
        stays: values.stays ? values.stays : this.form.stays
      } : {
        id: '',
        type: '',
        title: '',
        country: '',
        city: '',
        courses: [],
        stays: []
      })
    },
    page: function (dest) {
      this.$emit('emit', {
        action: 'page',
        data: dest
      })
    },
    insert: function (req) {
      if (
        req.type &&
        req.data &&
        this.form[req.type]
      ) {
        let idx = this.form[req.type].findIndex(it => {
          return it.id === req.data.id
        })
        if (idx >= 0) {
          this.form[req.type].splice(idx, 1, req.data)
        } else {
          this.form[req.type].push(req.data)
        }
      }
    },
    edit: function (req) {
      if (
        req &&
        req.type &&
        req.data &&
        req.data.id &&
        this.$refs[req.type]
      ) {
        this.$refs[req.type].open(req.data)
      }
    },
    remove: function (req) {
      if (
        req &&
        req.type &&
        req.data &&
        req.data.id &&
        this.form[req.type] &&
        this.form[req.type].length
      ) {
        let idx = this.form[req.type].findIndex(it => {
          return it.id === req.data.id
        })
        if (idx >= 0) {
          this.form[req.type].splice(idx, 1)
        }
      }
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isCoreLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading
      )
    },
    isValid () {
      return this.form.valid
    },
    isAcademicCourse () {
      return this.form.type === 'acadmic'
    },
    getTypeItems () {
      return Object.keys(this.$meta.arrange.types).map(key => {
        return {
          text: this.$meta.arrange.types[key],
          value: key
        }
      })
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).filter(key => {
        return key !== 'JP'
      }).map(key => {
        return {
          text: this.$meta.nations[key],
          value: key
        }
      })
    },
    getFormCourseItems () {
      return this.form.courses
    },
    getFormStayItems () {
      return this.form.stays
    }
  }
}
</script>
